import { Component, OnInit } from '@angular/core';
import { HomeSectionType } from '../../enums/home-section-type.enum';
import { HomeSectionModel } from '../../models/home-section.model';
import { environment } from 'src/environments/environment';
import { HomeImageService } from '../../services/home-image.service';
import { IdentityService } from 'src/app/@core/services/identity.service';
import { Router } from '@angular/router';
import { IdentityModel } from 'src/app/@core/models/identity.model';
import { orderSectionsForMode } from '../../services/home-section-order';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
  identity: IdentityModel = {} as IdentityModel;
  componentSequence = [
    { type: HomeSectionType.LiveCourses, sequence: 1 },
    { type: HomeSectionType.RecordedCourses, sequence: 2 },
    { type: HomeSectionType.LearningPaths, sequence: 3 },
    { type: HomeSectionType.Statistics, sequence: 4 },
    { type: HomeSectionType.Advertisements, sequence: 5 },
    { type: HomeSectionType.Partners, sequence: 6 },
    { type: HomeSectionType.TrainingCenters, sequence: 7 },
    { type: HomeSectionType.Instructors, sequence: 8 },
    { type: HomeSectionType.MiddleBanner, sequence: 9 },
    { type: HomeSectionType.Testimonials, sequence: 10 },
  ];

  courseTypeSectionsStatus: HomeSectionModel[] = [];
  showProcedures: boolean = environment.mohFeatures;
  sectionsShowInHome: HomeSectionModel[] = [];
  sectionsStatus: HomeSectionModel[] = [];
  get homeSections() {
    return HomeSectionType;
  }
  
  constructor(
    private homeImageService: HomeImageService,
    private identityService: IdentityService,
    private router: Router) {
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.loadSectionsStatus();
    this.identity = this.identityService.getIdentityModel();
  }

  loadSectionsStatus() {
    this.homeImageService.GetSections().subscribe((result: any) => {
      this.sectionsStatus = result.map((c: any) => ({...c, navPos: 'r'}));
      this.sectionsShowInHome = this.sectionsStatus
        .filter((c) => c.showInHome && c.section !== HomeSectionType.Features);
      this.courseTypeSectionsStatus = this.sectionsShowInHome = this.sectionsStatus
        .filter((c) => c.section === HomeSectionType.LiveCourses ||
        c.section === HomeSectionType.RecordedCourses);

      this.componentSequence.map(s => {
        s.sequence = this.sectionsStatus.filter(c => c.section === s.type)[0]?.sequence;
      });
      
      this.componentSequence.sort(function(a,b) {
        return a.sequence - b.sequence;
      });

      // Unified Code (criterion 7): the courses sections follow the hero directly.
      this.componentSequence = orderSectionsForMode(this.componentSequence, this.identityService.isUnifiedCode());
    });
  }

  showSection(section: HomeSectionType) {
    if (this.sectionsStatus) {
      return this.sectionsStatus.find((x) => x.section == section)?.showInHome;
    }
    return false;
  }

  getDetails(section: HomeSectionType): HomeSectionModel {
    if (!this.sectionsStatus) return;
    
    return this.sectionsStatus.find((x) => x.section == section);
  }
}
